module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAxBAMAAAB0TNefAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTCuC7i+A7i+A7S+A7i+A7TB/6C+B7i9/7S6A7TB/7C2C7y+A7cE2QWEAAAAMdFJOUwAf35vE7xBdgG8wPyvml7YAAADgSURBVDjLldQxDoJAEIVhbKyx8ABYioWVNhTQW5rQUFh4ABMv4BE4gIWFB/AMoAbjHMqFBUTC/Imv5EsmYd/OOs4/Oa5J9yIRcCCSXXReiEihs5RZMWcussTMcmK+u8gyZ1bGt5zv6i/XWScti9c5qIE8Dr15vRTMdXUq2+pUtuN1rqoDLqsDLqsjlpT5yfxiLpjfzCGyaZ3/i9jHQ63uq85LbCzG61BvWgJlm5y107YZTzr5jr7hlkS4RDmuYLMiCnu4/u16DnOKb4uvPlwJPCwmm6ao4UzhUTMZBdvf0R8jZnWlPJDxkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexqiye/jt.png
// module id = wH4c
// module chunks = 5